module.exports = __webpack_public_path__ + "../../../static/img/c_im_35.70b9d248.png";